import axios from 'axios';
import GetAssetPages, { assetPagesEnabled } from './GetAssetPagesFunction';

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const GET_ASSETS_URL = '/.netlify/functions/xServiceGetServiceContractUnits';

const GetAssetsListFunction = async (filter: string, token:string ,selectedContract:string) => {

  // A whole-customer list may come from paged files instead (PORTAL-72). Off unless this browser or this build
  // opted in, and anything it cannot do returns null and falls through to the call below, which is unchanged.
  // Only the plain whole-customer query qualifies: the pages hold the whole customer and nothing narrower.
  const wholeCustomer = /^<Filters><CustomerCode><Like>([A-Za-z0-9]+)<\/Like><\/CustomerCode><\/Filters>$/.exec(filter.replace(/\s+/g, ''));

  if (wholeCustomer && assetPagesEnabled()) {
    const fromPages = await GetAssetPages(token, wholeCustomer[1]);

    if (fromPages !== null) {
      return fromPages;
    }
  }

  const fetchData = async (): Promise<any> => {
      try {
        const assetDataRes = await axios({
          method: 'POST',
          url: GET_ASSETS_URL,
          headers: {
            'Content-Type': 'application/xml',
            'X-Pronto-Token': token,
          },
          data: `${filter}`,
        });

        if (assetDataRes.status === 200) {
          const units = assetDataRes.data.ServiceGetServiceContractUnitsResponse.ServiceContractUnits;
          if (!units || !units.ServiceContractUnit) {
            return [];
          }

          // PORTAL-63. fast-xml-parser returns a BARE OBJECT when the response holds
          // exactly one <ServiceContractUnit>, and an array when it holds several.
          // Every caller of this function treats the result as a list, so normalise
          // once here at the boundary rather than in each of them - which is what
          // had been happening, in three different and mutually inconsistent ways.
          //
          // This is also what the parser upgrade (PORTAL-51) will do via isArray, so
          // callers must already be array-only before that lands.
          const unit = units.ServiceContractUnit;
          return Array.isArray(unit) ? unit : [unit];
        }
      } catch (err) {
        if(err.response.status == 504) {
          throw(TIMEOUT);
        } else if(err.response.status == 401) {
            if(err.response.data == 'TokenExpired') {
              throw(TOKEN_EXPIRED);
            }
        }
      }
    };

    return fetchData();
};

export default GetAssetsListFunction;
